import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import Searcher from '../../../ReclamoCreation/components/tabs/components/searchFields/Searcher';
import { adaptContratosAsistencialArray } from '../../../../data/graphQL/queries/GestionAsistencial/getContratosAsistencial';
import moment from 'moment';
import { Grid } from '@mui/material';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import { TextInput } from '../../../../components/textInput/TextInput';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';

const ContratosSearcher = ({
    idPaciente,
    idEvaluacion,
    disabled,
    onSelectIdEvaluacion,
    onSelectEvaluacion,
    contratos,
    responseLoading,
    setPoseeEsquema
}) => {
    const [openModal, setOpenModal] = useState(false);
    const [entityValue, setEntityValue] = useState('');
    const rows = useMemo(() => adaptContratosAsistencialArray(contratos), [contratos]);
    const contratosLoading = responseLoading;

    const totalCount = useMemo(() => rows?.length || 0, [rows]);
    const CONFIGURATED_COLUMNS = useMemo(() => (generateColumnsDefaultConfiguration(columns)), [columns]);

    useEffect(() => {
        if (!rows?.length || !idEvaluacion) return;
        getSelectedEntity();
    }, [rows, idEvaluacion]);

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const handleChangeEntityValue = (row) => {
        setPoseeEsquema(row.planCuidadoPoseeEsquema)
        setEntityValue(getEntityValue(row));
    }

    const getSelectedEntity = () => {
        const selectedRow = rows?.find(row => row.idEvaluacion === idEvaluacion);
        onSelectEvaluacion(selectedRow)
        handleChangeEntityValue(selectedRow);
    }

    const handleRowClick = (params) => {
        onSelectIdEvaluacion(params?.row?.idEvaluacion);
        onSelectEvaluacion(params?.row)
        handleChangeEntityValue(params?.row);
        handleCloseModal();
    }

    const getEntityValue = (row) => {
        const value = !!row ? `${row.idEvaluacion} (${moment(row.fechaDesde).format('DD/MM/YYYY')} - ${moment(row.fechaHasta).format('DD/MM/YYYY')})` : null
        return value;
    }

    return <>
        <TextInput
            placeholder='Buscar Contrato'
            value={entityValue}
            shrink='true'
            label='Contrato'
            searchIcon
            onClick={handleOpenModal}
            disabled={disabled}
        />
        <CustomDialog
            maxWidth='md'
            fullWidth
            onCancel={handleCloseModal}
            open={openModal}
            cancelText='Cerrar'
            title='Buscador de contrato'
        >
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <DataGridGenerico
                        hideFooterPagination={false}
                        loading={contratosLoading}
                        toolbar={false}
                        columns={CONFIGURATED_COLUMNS}
                        rows={rows}
                        totalCount={totalCount}
                        onRowClick={handleRowClick}
                    />
                </Grid>
            </Grid>
        </CustomDialog>
    </>
}

export default ContratosSearcher;

const columns = [
    {
        headerName: 'Nro Contrato',
        field: 'idEvaluacion',
        flex: 15
    },
    {
        headerName: 'F. Desde',
        field: 'fechaDesde',
        type: 'date',
        flex: 10
    },
    {
        headerName: 'F. Hasta',
        field: 'fechaHasta',
        type: 'date',
        flex: 10,
    },
    {
        headerName: 'Programa',
        field: 'modulo',
        flex: 10,
    },
    {
        headerName: 'Plan',
        field: 'idPlanCuidado',
        flex: 10
    },
    {
        headerName: 'Nombre del Plan',
        field: 'nombrePlan',
        flex: 30,
    },
];